export class Barrio {
    codBarrio: number;
    nomBarrio: string;
    codParroquia: number;
    codCanton: number;
}
